import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'ro', name: 'Română' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' }
];

const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage =
    languages.find(lang => lang.code === language) || languages[0];

  return (
    <div className="relative" data-testid="language-selector">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors text-slate-300 hover:text-white"
        data-testid="language-button"
      >
        <Globe size={16} />
        <span className="text-sm font-light uppercase">
          {currentLanguage.code}
        </span>
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-[55]"
            onClick={() => setIsOpen(false)}
          />

          <div className="absolute right-0 mt-2 w-48 rounded-xl bg-gradient-to-b from-[#1e3a8a]/95 via-[#0f172a]/95 to-black/95 backdrop-blur-xl border border-white/10 shadow-xl z-[60] overflow-hidden">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => {
                  changeLanguage(lang.code);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-white/5 transition-colors text-left ${
                  language === lang.code ? 'bg-white/10' : ''
                }`}
                data-testid={`language-option-${lang.code}`}
              >
                <span className="text-xs font-semibold uppercase tracking-wide text-cyan-400 w-7">
                  {lang.code}
                </span>
                <span className="text-sm text-slate-300">
                  {lang.name}
                </span>

                {language === lang.code && (
                  <span className="ml-auto text-cyan-400 text-xs">✓</span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;
